import React from 'react'
import PropTypes from 'prop-types'
import { t } from 'src/lib/i18n-react'
import { Box } from '@chatterbug/aaron'

import SelfAssessment from 'src/pages/LearningLanguageLevelAssessment/subcomponents/SelfAssessment/SelfAssessment'
import PlacementTestChooser from 'src/pages/LearningLanguageLevelAssessment/subcomponents/PlacementTestChooser/PlacementTestChooser'
import LanguageCardWithAvatarSkeleton from 'src/ui/LanguageCardWithAvatar/LanguageCardWithAvatarSkeleton'
import LanguageAvatar from 'src/ui/LanguageAvatar/LanguageAvatar'

const TITLES = {
  known: t('Choose where to start'),
  unknown: t('Help me choose'),
}

const LevelAssessmentCard = ({
  levelKnown,
  languageCode,
  open,
  onClick,
  levels,
  onSubmitLevel,
  currentLevel,
  isSignup,
}) => {
  const handleInteraction = (event) => {
    if (event?.key === 'Enter') {
      onClick(levelKnown ? 'known' : 'unknown')
    }
  }

  return (
    <LanguageCardWithAvatarSkeleton
      onClick={() => onClick(levelKnown ? 'known' : 'unknown')}
      open={open}
      headerSection={
        <Box
          as="a"
          role="link"
          aria-expanded={open}
          display="inline"
          sx={{
            ':hover': {
              textDecoration: 'none',
              color: 'black',
            },
            ':focus, :active': {
              textDecoration: 'none',
              color: 'black',
            },
          }}
          variant="text.h3"
          tabIndex="0"
          data-testid="card-header"
          onKeyPress={handleInteraction}
        >
          {TITLES[levelKnown ? 'known' : 'unknown']}
        </Box>
      }
      avatarSection={
        <LanguageAvatar
          languageCode={languageCode}
          variant={levelKnown ? 'regular' : 'confused'}
        />
      }
    >
      {levelKnown ? (
        <SelfAssessment
          levels={levels}
          onClick={onSubmitLevel}
          currentLevel={currentLevel}
          isSignup={isSignup}
        />
      ) : (
        <PlacementTestChooser
          isSignup={isSignup}
          languageCode={languageCode}
          levels={levels}
        />
      )}
    </LanguageCardWithAvatarSkeleton>
  )
}

LevelAssessmentCard.propTypes = {
  open: PropTypes.bool,
  onClick: PropTypes.func,
  levelKnown: PropTypes.bool,
  languageCode: PropTypes.string,
  levels: PropTypes.array,
  onSubmitLevel: PropTypes.func,
  currentLevel: PropTypes.object,
  isSignup: PropTypes.bool,
}

export default LevelAssessmentCard
